import { User } from "./user";

export enum OrgNameEnum {
    ANDO = "ANDO",
    REGION_10 = "R10",
    CIPW = "CIPW",
    FICW = "FICW",
    MSCF = "MSCF",
    RD10 = "RD10",
}

export class Organization {
    id: number;
    name: string;
    shortName: string;
    flag: boolean;
    disableDelete: boolean;
    isRemoveAllowed: boolean;
    sameOrgUser: boolean;

    constructor(input) {
        this.id = input.organizationId;
        this.name = input.organizationName;
        this.shortName = input.organizationShortName;
    }
}

export class OrgUsers extends Organization {
    users: Array<User>;
    orgValue?: string;
    constructor(input) {
        super(input[0]);
        input && (this.users = input);
    }
}
